module.exports = __webpack_public_path__ + "static/media/skating.a3b5107b.svg";